export default function() {
  return [
    // {
    //   title: "Blog Dashboard",
    //   to: "/blog-overview",
    //   htmlBefore: '<i class="material-icons">edit</i>',
    //   htmlAfter: ""
    // },
    // {
    //   title: "Blog Posts",
    //   htmlBefore: '<i class="material-icons">vertical_split</i>',
    //   to: "/blog-posts",
    // }
    // ,
    // {
    //   title: "Add New Post",
    //   htmlBefore: '<i class="material-icons">note_add</i>',
    //   to: "/add-new-post",
    // }
    // ,
    // {
    //   title: "Forms & Components",
    //   htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/components-overview",
    // }
    // ,
    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: "/tables",
    // },
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/user-profile-lite",
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors",
    // },
    // {
    //   title: "Dashboard",
    //   htmlBefore: '<i class="material-icons">insights</i>',
    //   to: "/dashboard",
    // },
    {
      title: "Metering",
      htmlBefore: '<i class="material-icons">insights</i>',
      to: "/dashboard-advance",
    }
    // ,
    // {
    //   title: "Settings",
    //   htmlBefore: '<i class="material-icons">settings</i>',
    //   to: "/settings",
    // }
    // ,
    // {
    //   title: "Devices",
    //   htmlBefore: '<i class="material-icons">memory</i>',
    //   to: "/devices",
    // },
    // {
    //   title: "Device Types",
    //   htmlBefore: '<i class="material-icons">developer_board</i>',
    //   to: "/devicetypes",
    // },
    // {
    //   title: "Locations",
    //   htmlBefore: '<i class="material-icons">place</i>',
    //   to: "/locations",
    // },
    // {
    //   title: "Users",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/users",
    // }
  ];
}
